import includes from 'ramda/src/includes';

export const isIncludeTdc = includes("tdc");
